var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33784 5.33794C0.511835 10.1639 0.511835 17.8361 5.33784 22.6621C10.1638 27.4881 17.836 27.4881 22.662 22.6621C27.488 17.8361 27.488 10.1639 22.662 5.33794C17.8359 0.511938 10.1638 0.511938 5.33784 5.33794ZM21.672 14.9899L14.9898 14.9899L14.9898 21.6721L13.0099 21.6721L13.0099 14.9899L6.32779 14.9899L6.32779 13.01L13.0099 13.01L13.0099 6.32789L14.9898 6.32789L14.9898 13.01L21.672 13.01L21.672 14.9899Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus1);
export default __webpack_public_path__ + "static/media/plus_1.5e5d7a9c4c2d1150367b5c00b5ddd661.svg";
export { ForwardRef as ReactComponent };